// extracted by mini-css-extract-plugin
export default {"tableContainer":"SearchPortfolioContent_tableContainer__fqO3D","table":"SearchPortfolioContent_table__fPaJM"};